module.exports = __webpack_public_path__ + "static/2007-layer-2-a92f845810577844739a4aa2e613e6a7.png";